var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEye = function SvgEye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 11.5c-2.775 0-5.251-1.769-7.424-5.234a.5.5 0 0 1 0-.532C2.75 2.27 5.225.5 8 .5s5.251 1.769 7.424 5.234a.5.5 0 0 1 0 .532C13.25 9.73 10.775 11.5 8 11.5m0-10C5.687 1.5 3.553 2.978 1.593 6 3.553 9.022 5.687 10.5 8 10.5s4.447-1.478 6.407-4.5C12.447 2.978 10.313 1.5 8 1.5m0 8a3.5 3.5 0 1 1 0-7 3.5 3.5 0 0 1 0 7m0-1a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
  })));
};
export default SvgEye;